// extracted by mini-css-extract-plugin
export default {"QuestionHeader":"QuestionHeader-module-a0bf537e24a43af41d98","text":"QuestionHeader-module-e4fe01c075eef87c28f9"};